export default __webpack_public_path__ + "static/media/3.e7315fa9.svg";